import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { loadBrokerConfigData, loadBrokerConfigDataSuccess, loadBrokerConfigDataFailure } from '../actions/brokerConfig.actions';
import { environment } from 'src/environments/environment';
import { selectBrokerConfigData } from '../selectors/brokerConfig.selector';
import { select, Store } from '@ngrx/store';

@Injectable()
export class BrokerConfigEffects {
  loadBrokerConfigData$;
  constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
    this.loadBrokerConfigData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadBrokerConfigData),
        withLatestFrom(this.store.pipe(select(selectBrokerConfigData))),
        switchMap(([action, currentData]) => {
          console.log({currentData})
          if (currentData != undefined && Object.keys(currentData).length > 0) {
            console.log('Data already in store, no need to call API');
            console.log('return old fetch', new Date().toISOString())
            return;
          }
          const { id } = action;
          const api = this.getApiEndpoint(id);
          const apiUrl = `${environment.apiUrl.replace(/\/$/, '')}${api}`;
          const headers = {
            'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
            'Content-Type': 'application/json'
          };
          return this.http.get<any>(apiUrl, { headers }).pipe(
            map((data) => {
              console.log('Fetched new data:', data);
              console.log('new fetch', new Date().toISOString())
              return loadBrokerConfigDataSuccess({ brokerConfigData: data.data });
            }),
            catchError((error) => {
              console.error('API Error:', error);
              const errorMessage = error?.message || 'An unknown error occurred';
              return [loadBrokerConfigDataFailure({ error: errorMessage })]; // Dispatch failure on error
            })
          );
        })
      )
    );
  }

  private getApiEndpoint(id): string {
    return `/api/ap/v2/first/broker/formConfig?currentBrokerId=${id}`
    // return `/api/ap/broker/formConfig?currentBrokerId=${id}`
  }
}
